import { connect } from "react-redux";

import DealColumnsModal from "./DealColumnsModal";

const mapStateToProps = ({ currentUser, loading }) => ({
  loading: loading.user,
  userID: currentUser.id,
});

export default connect(mapStateToProps)(DealColumnsModal);
